import { QueryClient, useQuery } from '@tanstack/react-query';
import { ContestApi } from 'api/ApiHelper';
import { contestsQueryKey } from 'queries/contests/queryKey';

export const useGetContestVotePeriodQuery = (contestId: number) =>
  useQuery({
    queryKey: contestsQueryKey.contestsVotePeriod(contestId),
    queryFn: () => ContestApi.getVotePeriod(contestId),
    enabled: contestId > 0,
    staleTime: 1000 * 60 * 5,
  });

export const prefetchContestVotePeriodQuery = (queryClient: QueryClient, contestId: number) =>
  queryClient.prefetchQuery({
    queryKey: contestsQueryKey.contestsVotePeriod(contestId),
    queryFn: () => ContestApi.getVotePeriod(contestId),
    staleTime: 1000 * 60 * 5,
  });
